<template>
  <pricing-card plan="Pro" sub-title="Unlimited domains" :list="list" price-slider />
</template>

<script>
import PricingCard from "./index";

export default {
  name: "Pro",
  components: {
    PricingCard,
  },
  data() {
    return {
      list: [
        { include: true, text: 'Clickcease™ bot detection' },
        { include: true, text: 'IP blocking' },
        { include: true, text: 'Cross-domain blocking' },
        { include: true, text: 'Session recordings and analysis' },
        { include: true, text: 'Adspy - competitor ad intel' },
        { include: true, text: 'Account overview' },
        { include: true, text: 'Dedicated account manager' },
      ],
    };
  },
}
</script>